export default function removeByKey(originalObj, deleteKey) {
  return Object.keys(originalObj)
    .filter((key) => key !== deleteKey)
    .reduce((obj, key) => ({
      ...obj,
      [key]: originalObj[key]
    }), {});
}
